<template>
    <b-modal v-model="show" title="АНАЛОГ СОЗЛАШ" :centered="true" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                  <div class="card card-tasks">
                    <div class="card-header">
                      <h4 class="card-title" v-if="analogSettingItem">
                        <span v-if="analogSettingItem.category === 'ResidentialIndividual'">Турар</span>
                        <span v-else-if="analogSettingItem.category === 'ResidentialMultiStorey'">Кўп қаватли</span>
                        <span v-else-if="analogSettingItem.category === 'NotResidential'">Нотурар</span>
                      </h4>
                    </div>
                    <div class="card-body">
                        <template v-if="analogSetting">
                          <div class="form-group">
                            <label>Вилоят</label>
                            <label class="form-control">{{analogSetting.province.name}}</label>
                          </div>
                          <div class="form-group">
                            <label>Туман</label>
                            <label class="form-control">{{analogSetting.region.name}}</label>
                          </div>
                          <div class="form-group">
                            <label>МФЙ</label>
                            <label class="form-control">{{analogSetting.mfy.name}}</label>
                          </div>
                          <div class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                <label>Сўмдан <span class="red">*</span></label>
                                <numeric-input v-model="minAmount"></numeric-input>
                                <div class="red" v-if="$v.minAmount.$error">Илтимос кийматни киритинг</div>
                              </div>
                              <div class="col-md-6">
                                <label>Гача <span class="red">*</span></label>
                                <numeric-input v-model="maxAmount"></numeric-input>
                                <div class="red" v-if="$v.maxAmount.$error">Илтимос кийматни киритинг</div>
                                <div class="red" v-if="$v.maxA.$error">
                                  {{minAmount}} сўм - кийматдан катта булиш керак
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
          <button class="all-btn add-btn float-right" @click="saveManually" :disabled="processing || loading">
            {{$t('action.refresh')}}
          </button>
          <button class="all-btn delete-btn float-right mr-2" @click="show = false">
            {{$t('action.cancel')}}
          </button>
        </div>
    </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import {minValue, required, requiredUnless} from "vuelidate/lib/validators";

export default {
        name: "AnalogSettingEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
          return {
            show: false,
            loading: false,
            processing: false,
            analogSetting: null,
            analogSettingItem: null,
            minAmount: null,
            maxAmount: null
          }
        },
      validations() {
          return {
            minAmount: {
              required: required,
              minValue: minValue(0.01)
            },
            maxAmount: {
              required: required,
              minValue: minValue(0.01)
            },
            maxA: {
              required: requiredUnless(() => {
                return !!(this.validMax)
              })
            }
          }
      },
      computed: {
        validMax() {
          return this.maxAmount >= this.minAmount;
        }
      },
        methods: {
          saveManually() {
            console.log(this.analogSetting)
            this.$v.$touch();
            if (this.$v.$invalid) {
              return;
            }

            const items = []

            const item = {
              min: this.minAmount,
              max: this.maxAmount,
              action: 'MANUALLY',
              category: this.analogSettingItem.category
            }

            items.push(item)

            const analogSettingRequest = {
              id: this.analogSetting.id,
              province: this.analogSetting.province,
              provinceId: this.analogSetting.province.id,
              regionId: this.analogSetting.region.id,
              mfyId: this.analogSetting.mfy.mfyId,
              action: 'ACTIVE',
              items: items,
              updatingCategory: this.analogSettingItem.category
            }

            console.log('request =', analogSettingRequest)

              this.processing = true;
              this.$http.post('/analog-setting/save-manually', analogSettingRequest)
                  .then(res => {
                    let resData = res.data;
                    if (resData.status === 'SUCCESS') {
                          this.analogSetting = null
                          this.analogSettingItem = null
                          this.minAmount = null
                          this.maxAmount = null
                      this.show = false;
                      this.$emit('change');
                    }
                    this.processing = false;

                  }).catch(({response}) => {
                console.log('error')
                console.log(response)

                this.$swal({
                  type: 'error',
                  title: '',
                  text: response && response.data.message ? response.data.message : response.data
                });

                this.processing = false;
              })
          },
          editAnalogSetting(analogSettingId) {
            this.loading = true;
            this.$http.get(`/analog-setting/${analogSettingId}`)
                .then(res => {
                  this.analogSetting = res.data
                  this.loading = false;

                }).catch(({response}) => {
                  console.log('error')
                  console.log(response)

                  this.$swal({
                    type: 'error',
                    title: '',
                    text: response && response.data.message ? response.data.message : response.data
                  });

                  this.loading = false;
            })
          }
        },
        created() {
           this.$eventBus.$on('showAnalogSettingItemAddModal', (data) => {
               if (data && data.analogSettingId) {
                 this.analogSettingItem = data
                 this.minAmount = data.min
                 this.maxAmount = data.max
                 this.editAnalogSetting(data.analogSettingId)
               }
               this.show = true;
           });
        }
    }
</script>

<style scoped>

</style>